import { c as _c } from "react/compiler-runtime";
import { useEnsName } from "wagmi";
interface Props {
  address: string;
}
export default function DelegationWallet(props) {
  const $ = _c(7);
  const t0 = props.address as `0x${string}`;
  let t1;
  if ($[0] !== t0) {
    t1 = {
      address: t0,
      chainId: 1
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const ensResolution = useEnsName(t1);
  if (ensResolution.data) {
    let t2;
    if ($[2] !== ensResolution.data || $[3] !== props.address) {
      t2 = <span>{ensResolution.data} - {props.address}</span>;
      $[2] = ensResolution.data;
      $[3] = props.address;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    return t2;
  } else {
    let t2;
    if ($[5] !== props.address) {
      t2 = <span>{props.address}</span>;
      $[5] = props.address;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    return t2;
  }
}